import "./aboutus.scss";
import { inject, observer } from "mobx-react";
import { useEffect } from "react";
import LoadedComponent from "./LoadedComponent/index";
import parse from "html-react-parser";

const AboutUs = ({ getStaticPage, about, isLoading }) => {
  useEffect(() => {
    window.scrollTo(0, window.offsetTop);
    getStaticPage("about");
  }, []);

  return (
    <div className="aboutus-page-wrapper">
      <div className="aboutus-page">
        <LoadedComponent isLoading={isLoading}>{parse(about)}</LoadedComponent>
      </div>
    </div>
  );
};

export default inject(({ documentsStore }) => {
  const { getStaticPage, about, isLoading } = documentsStore;
  return {
    getStaticPage,
    about,
    isLoading
  };
})(observer(AboutUs));
